/* pp-discordfix.js - moved out of sections/pp-discordfix.liquid on 2026-09-05 (pp-lcp): this used to run inline in the header group,
   before the page content had even been parsed. As a deferred asset it runs after parsing and is cached across pages. */
(function(){
  function align(){
    try{
      var fab=document.querySelector('.pp-discord-fab');
      var host=document.querySelector('shopify-chat');
      if(!fab||!host||!host.shadowRoot)return;
      var vh=innerHeight,iw=innerWidth,best=null,ba=0;
      var ns=host.shadowRoot.querySelectorAll('*');
      for(var i=0;i<ns.length;i++){
        var r=ns[i].getBoundingClientRect();
        if(r.width>=40&&r.width<=240&&r.height>=28&&r.height<=90&&r.bottom>vh-360&&(r.left<240||iw-r.right<240)){
          var a=r.width*r.height;if(a>ba){ba=a;best=r;}
        }
      }
      if(!best)return;
      var c=vh-(best.top+best.height/2);
      var fh=fab.getBoundingClientRect().height||50;
      var t=Math.round(c-fh/2);
      if(t<8)t=8;
      if(t>vh/2)return;
      fab.style.bottom=t+'px';
    }catch(e){}finally{
      try{
        var discord=document.querySelector('.pp-discord-fab');
        var telegram=document.querySelector('.pp-telegram-fab');
        if(discord&&telegram){
          var bottom=parseFloat(getComputedStyle(discord).bottom);
          var height=discord.getBoundingClientRect().height;
          if(isFinite(bottom))telegram.style.bottom=Math.round(bottom+height+10)+'px';
        }
      }catch(e){}
    }
  }
  function init(){
    align();
    [500,1200,2500,4500].forEach(function(d){setTimeout(align,d);});
    var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(align,160);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
